<template>
  <v-container>
  <v-data-table
    :headers="adjHeaders"        
    :items="adjlist"       
    group-by="grpNm" 
    item-key="id"
    item-value="enm"
  > 
  
  <template v-slot:top>
    <v-toolbar flat color='cyan lighten-5' >          
      <v-toolbar-title  class="text-h5"   v-if="gmgrYn != 'Z'" >{{ formTitle }}</v-toolbar-title>  
   
      <span  class="text-subtitle-1"  v-if="gmgrYn === 'Z'" >{{ formTitle }} </span>

      <v-select v-if="gmgrYn === 'Z'" class="text-subtitle-1 ml-5" v-model="gMgrDiv.select"  :items="gMgrDiv.items"  item-text="name" item-value="cd"  color="blue" 
              return-object single-line  @change="getAdjustList()"
                  >
      </v-select>
     
      

      <v-spacer></v-spacer>      
      <v-btn icon>        
        <v-icon color="green" @click="adjSave()">  
          mdi-content-save</v-icon>
      </v-btn>

    </v-toolbar>         
  </template>

    <template v-slot:group.header="{items, isOpen, toggle}">
      <th colspan="2" >
        <v-icon @click="toggle"
          >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
        </v-icon>
        {{ items[0].grpNm }}
      </th>
    </template>


  <template #[`item.adjRst`]="{ item }">
      <v-chip
          small
        :color="getColor(item.adjRst)"
        dark
      >
        {{ item.adjRst }}
      </v-chip>
  </template>
 
  <template #[`item.enm`]="{ item }">
      <v-chip class="ma-2" color="indigo" text-color="white" small
      > {{ item.rnk }} 
      </v-chip>
      <v-chip class="ma-2" color="indigo" text-color="white" small
      > {{ item.enm }} 
      </v-chip>
      <v-chip class="ma-2" color="indigo" text-color="white" small
      > {{ item.posNm }} 
      </v-chip>
  </template>
  
   <template v-slot:item.newadjRst="{ item }">
    <!-- <v-text-field v-model="editedItem.newadjRst" dense single-line  :autofocus="true" v-if="item.effEmpno === editedItem.effEmpno"></v-text-field> -->
        <v-select   v-model="editedItem.newadjRst"
                    :items="newadjRsts"                                                
                    color="blue"
                    v-if="item.effEmpno === editedItem.effEmpno" 
                    @change="adjKeep()"
                    >
        </v-select>
    <span v-else>{{item.newadjRst}}</span>
  </template>  
  <template v-slot:item.rmk="{ item }">
    <v-text-field v-model="editedItem.rmk" dense single-line :autofocus="true" v-if="item.effEmpno === editedItem.effEmpno"></v-text-field>
    <span v-else>{{item.rmk}}</span>
  </template>    
  <template v-slot:item.actions="{ item }">
      <div v-if="item.effEmpno === editedItem.effEmpno">
        <v-icon color="red" class="mr-3" @click="closeEff">
          mdi-window-close
        </v-icon>
        <v-icon color="green" @click="adjKeep(item)">
          mdi-book-open
        </v-icon>        
      </div>
      <div v-else>
        <v-icon color="green" class="mr-3" @click="editItem(item)">
          mdi-pencil
        </v-icon>           
      </div>      
  </template>
          
  </v-data-table>  

 <!-- Scroll To Top -->
  <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="green" @click="toTop">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>

    <VueToastify :notifyAction="notifyAction"></VueToastify>    
   </v-container> 
 
</template>

<script>


import {getEvlAdjDetail, chkGmgr, insertAdjEvl} from '@/api/view/mis/10/v10a4000.js' 
import VueToastify from '@/components/toastify/VueToastify.vue'
import baseview from '@/components/base/baseview.vue'

export default {
  mixins: [baseview],
  components: { 
      VueToastify,   
    },
    
  data: () => ({        
     
    adjHeaders: [      
      { text: 'Name', sortable: false, divider: true, value: 'enm' ,  align: 'start', groupable: false},      
      { text: 'Present Rate', sortable: false, divider: true, value: 'adjRst', align: 'end' },
      { text: 'Adjusted Rate', sortable: false, divider: true, value: 'newadjRst', align: 'end', width: '50%'},
      { text: 'Remark', sortable: false,divider: true,  value: 'rmk' , align: 'end'},
       {text: 'Edit & Ref.',  value: 'actions', sortable: false,  divider: true, align: 'end' }
    ],    
    newadjRsts:['A', 'B', 'C', 'D', 'E'],    
    mobile: true,
    adjlist: [],
    adjlistbk:[],
    editedIndex: -1,    
    editedItem: {
      effEmpno:'',
      enm: '',
      adjRst: '',
      newadjRst: '',
      rmk: ''
    },
    defaultItem: {
        effEmpno:'',
      enm: '',
      adjRst: '',
      newadjRst: '',
      rmk: ''
    },
    evlYr: 0,
    evlSrl: '',
    gmgrYn: '',

    gMgrDiv: {
        select: { name: 'BOD', cd: 'N' },
        items: [
          { name: 'BOD', cd: 'N' },
          { name: 'G.Mgr', cd: 'Y' }
        ]
      },
    
    fab: false,  
    returnVar : 'N'
  }),

  computed: {

    formTitle () {
      let frmTle = '';
      var date = new Date();    

      if (date.getMonth() < 6) {
        frmTle = 'I'             
      } 
      else
      {
        frmTle = 'II'        
      }
      if (this.gmgrYn =='Z') {
        frmTle = 'Select Position:' 
      }
      else {        
        frmTle =  'Evaluation Term: ' + frmTle + '/' + date.getFullYear();
      }
      return frmTle
    },

   
  },

  
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () { 

      this.assignEvl()          
      this.chkGmgr()          
             
    },
    
    chkGmgr() {
      
      let params = {
                        evlYr: this.evlYr.toString(),
                        evlSrl:this.evlSrl,
                       // evlSrl: '1',
                        userId: this.$store.state.user.userId, 
                        //userId : 'A513944',
                      }
          chkGmgr(params).then(res => {     
              //  console.log('res.list[0].gmgryn', res.list[0].gmgryn)                                        
                res.list.forEach(e => {                    
                      this.gmgrYn = res.list[0].gmgryn                    
                  });                    
                  this.getAdjustList()    
                })
      
                          

    },

    assignEvl () {
    
      var date = new Date();
      this.evlYr = date.getFullYear();
      if (date.getMonth() < 6) {             
        this.evlSrl = '1'; 
      } 
      else
      {
        this.evlSrl = '2';   
      }
    },

    //getAdjustList
    async getAdjustList() {                           
        
        try {
            // this.openLoading('searching')
            let params = {
                        userId: this.$store.state.user.userId, 
                       // userId : 'A513944',        
                        evlYr: this.evlYr.toString(),
                        evlSrl: this.evlSrl,                        
                        evlDate: this.evlDate,                        
                        gmgr: this.gmgrYn == 'Z' ? this.gMgrDiv.select.cd :this.gmgrYn
                        
                      }
                

                await getEvlAdjDetail(params).then(res => {
                let list = []
                let cnt = 1;                
                res.list.forEach(e => {
                  list.push(
                  {
                     id: cnt++, rnk: e.rnk, enm: e.enm, effEmpno:e.effEmpno, posCd: e.posCd, posNm:e.posNm,
                     adjRst: e.adjRst, newadjRst: '', appCd: e.appCd, dutyCd: e.dutyCd, rmk: e.rmk,
                     evlGrp: e.evlGrp, grpNm:e.grpNm, evlPoscd: e.evlPoscd, evlObj: e.evlObj, grpQty: e.grpQty
                  }
                )              
                  });
                  this.adjlist = list                  
                  this.adjlistbk = this.$_.cloneDeep(this.adjlist)
                  //   this.adjlistbk = list
                  // console.log(this.adjlist)         
                })


            } finally {                
                // this.endLoading()
            }

      },

    getColor (adjRst) {

        if (adjRst =='A'||adjRst =='B') return 'green'
        else if (adjRst =='C') return 'yellow'
        else if (adjRst =='D') return 'orange'
        else return 'red'
      },  

    
    editItem (item) {
      
      this.editedIndex = this.adjlist.indexOf(item);      
      this.editedItem = Object.assign({}, item);      
      
    },


    closeEff (item) {      

      this.$nextTick(() => {        
        this.adjlist[this.editedIndex].newadjRst = '';
        this.adjlist[this.editedIndex].rmk = '';
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
   
    adjKeep (item) { 
      let adjOld = 0      
      let adjNew = 0
      let appCd = this.editedItem.appCd

      this.adjlist[this.editedIndex].newadjRst = this.editedItem.newadjRst;
      this.adjlist[this.editedIndex].rmk = this.editedItem.rmk;
      if (this.editedItem.adjRst == 'A' )
            {
              adjOld = 5
            }  
            else if (this.editedItem.adjRst == 'B' ) {
              adjOld = 4
            }  
            else if (this.editedItem.adjRst == 'C' ) {
              adjOld = 3
            }  
            else if (this.editedItem.adjRst == 'D' ) {
              adjOld = 2
            }  
            else if (this.editedItem.adjRst == 'E' ) {
              adjOld = 1
            }  

            if (this.editedItem.newadjRst == null) {
              adjNew = adjOld
            }
            else{
                  if (this.editedItem.newadjRst == 'A' ) {
                    adjNew = 5
                  }  
                  else if (this.editedItem.newadjRst == 'B' ) {
                    adjNew = 4
                  }  
                  else if (this.editedItem.newadjRst == 'C' ) {
                    adjNew = 3
                  }  
                  else if (this.editedItem.newadjRst == 'D' ) {
                    adjNew = 2
                  }  
                  else if (this.editedItem.newadjRst == 'E' ) {
                    adjNew = 1
                  }  
                }
        
        if (Math.abs(adjNew - adjOld) > 2)
        {           
             this.vToastify(this.$t('Please check your adjusted rate. ' + this.editedItem.grpNm), 'warn') 
        }
        else{             
            if (( appCd == null || appCd != 'DB') && Math.abs(adjNew - adjOld) == 2) 
            {
              this.vToastify(this.$t('Please check your adjusted rate.' + this.editedItem.grpNm), 'warn') 
            }

        }


    },

    adjSave(){
      let params = []
      let prs = {}
      let chkEvlGap ='N'
      // this.returnVar == 'N'
      // this.vToastify(this.$t('Please check your adjusted rate.'), 'warn') 
      this.chkEvlRate();

      console.log("adjSave",  this.returnVar )

      if (this.returnVar == 'Y')
      {
        for(let i = 0; i < this.adjlist.length; i++) {
                prs = {}                                 
                prs.evlYr = this.evlYr.toString(),
                prs.evlSrl =  this.evlSrl                               
                prs.effEmpno = this.adjlist[i].effEmpno
                prs.evlPoscd = this.adjlist[i].evlPoscd
                prs.evlEpmno =  this.$store.state.user.userId
                        
                if (this.adjlist[i].rmk == null) {
                    prs.adjRmk   = '.'
                }  
                else {    
                    prs.adjRmk   = this.adjlist[i].rmk
                }                 
                if (this.adjlist[i].evlObj == 'F') {
                  prs.adjRmk2 = 'A'
                }
                else {
                  prs.adjRmk2 = 'P'
                }                
                if (this.adjlist[i].newadjRst != null && this.adjlist[i].newadjRst != '' && this.adjlist[i].newadjRst != this.adjlist[i].adjRst)
                {
                  prs.adjRst = this.adjlist[i].newadjRst
                  params.push(prs) 
                }  

            }
        //  console.log(params)    

         insertAdjEvl(params).then(res => {              

              const msg = res.body

              if(msg === 'Y') {
                this.vToastify(this.$t("Insert successfully!"), 'warn')
                this.getAdjustList()
              } else {
                this.vToastify(this.$t("An error has occured while updating data to ...."), 'warn')
              }
            }).catch(error => {
              this.vToastify(error, 'warn')
            }).finally(() => {
              // this.endLoading()
            })


      }

    },

    chkEvlRate() {      
      let adjOld = 0      
      let adjNew = 0 
      let adjCal = 0   
      let adjCalOld = 0   
      let grpOld = ''  
      let grpOldQty = '0'
      this.returnVar ='Y'   
      
      // console.log(this.adjlist.length)

      for (let i=0; i<this.adjlist.length; i++)
      {    
            
          //  if (this.returnVar =='Y' && (this.adjlist[i].newadjRst != null && this.adjlist[i].newadjRst != ''))
          //   {
              // console.log(i, this.adjlist[i].grpNm + ':' + this.adjlist[i].enm +  ':' + this.adjlist[i].adjRst  + ':' + this.adjlist[i].newadjRst)  

                if (this.adjlist[i].adjRst == 'A' ) {
                  adjOld = 5
                }  
                else if (this.adjlist[i].adjRst == 'B' ){
                  adjOld = 4
                }  
                else if (this.adjlist[i].adjRst == 'C' ){
                  adjOld = 3
                }  
                else if (this.adjlist[i].adjRst == 'D' ){
                  adjOld = 2
                }  
                else if (this.adjlist[i].adjRst == 'E' ){
                  adjOld = 1
                }  

                if (this.adjlist[i].newadjRst == null || this.adjlist[i].newadjRst =='')
                {
                  adjNew = adjOld                
                }
                else{
                      if (this.adjlist[i].newadjRst == 'A' ) {
                        adjNew = 5
                      }  
                      else if (this.adjlist[i].newadjRst == 'B' ) {
                        adjNew = 4
                      }  
                      else if (this.adjlist[i].newadjRst == 'C' ) {
                        adjNew = 3
                      }  
                      else if (this.adjlist[i].newadjRst == 'D' ) {
                        adjNew = 2
                      }  
                      else if (this.adjlist[i].newadjRst == 'E' ) {
                        adjNew = 1
                      }  
                    }
                    
                    // Check adj evaluation    
                    if (grpOld === '' || grpOld == this.adjlist[i].grpNm)
                      {
                        adjCal = adjCal + (adjNew - adjOld)       
                      }
                    else{
                        adjCalOld  = adjNew - adjOld
                    }  


                    if ((grpOld != ''  &&  grpOld != this.adjlist[i].grpNm) || ( i == this.adjlist.length - 1) )
                    {
                       
                        if ((adjCal != 0) && (grpOldQty > 1 || (grpOldQty == 0 && this.adjlist[i].grpQty > 1)) ){
                          console.log('adjCal', adjCal)
                          console.log('grpOld', grpOld)
                          console.log('this.adjlist[i].grpNm', this.adjlist[i].grpNm)
                          this.vToastify(this.$t('Please check your adjusted rate.'+ this.adjlist[i].grpNm), 'warn') 
                          this.returnVar = 'N'
                          adjCal = 0
                        }
                        else  {
                              adjCal = adjCal + adjCalOld 
                        }

                    }
                    
                   //|| ( i == this.adjlist.length - 1 && this.adjlist[i].grpQty > 1))

                    
                grpOld = this.adjlist[i].grpNm   
                grpOldQty = this.adjlist[i].grpQty               
          }
          
      // }
      console.log('This.returnVar', this.returnVar)

      return this.returnVar;

    },

    onScroll(e) {
          if (typeof window === 'undefined') return
          const top = window.pageYOffset || e.target.scrollTop || 0
          this.fab = top > 20
        },
        toTop() {
          this.$vuetify.goTo(0)
      },


    notifyAction(notifyInfo, action) {
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
    },

  },
  mounted(){ 
    
    
    
  }
}
</script>

<style >
  .v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__prefix, .v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__suffix, .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    padding: 4px 0 2px;
    text-align: right;
    width: 50px;
  }

  .theme--light.v-select .v-select__selections {
    color: rgba(0, 0, 0, 0.87);
    min-height: 10px;
    width: 30px;
  } 
</style>